export var SpaceMember;
(function (SpaceMember) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/halo/credentials.proto}
     */
    let Role;
    (function (Role) {
        Role[Role["INVALID"] = 0] = "INVALID";
        Role[Role["ADMIN"] = 1] = "ADMIN";
        Role[Role["MEMBER"] = 2] = "MEMBER";
        Role[Role["READER"] = 3] = "READER";
    })(Role = SpaceMember.Role || (SpaceMember.Role = {}));
})(SpaceMember || (SpaceMember = {}));
export var AdmittedFeed;
(function (AdmittedFeed) {
    /**
     * Defined in:
     *   {@link file://./../../../dxos/halo/credentials.proto}
     */
    let Designation;
    (function (Designation) {
        Designation[Designation["GENERAL"] = 0] = "GENERAL";
        Designation[Designation["CONTROL"] = 1] = "CONTROL";
        Designation[Designation["DATA"] = 2] = "DATA";
    })(Designation = AdmittedFeed.Designation || (AdmittedFeed.Designation = {}));
})(AdmittedFeed || (AdmittedFeed = {}));
//# sourceMappingURL=credentials.js.map